import { Bookmark } from "lucide-react";

import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { setMyViewsPanelOpen, useMyViewsPanelOpen } from "@/hooks/useMyViewsPanel";
import { cn } from "@/lib/utils";

/**
 * "My views" in the top bar, beside the notifications bell — the saved-items
 * shortcut Salesforce's Favorites star and Jira's Starred menu put in the
 * same place. It opens the "My views" panel at the right of the page
 * (`MyViewsPanel`) and closes it again; lit while it is open.
 *
 * In the top bar rather than the sidebar because it is a shortcut, not a page:
 * a sidebar row reads as somewhere to go. Market Intelligence's own control
 * (`ModuleDefinition.topbarAction`), so it shows in this module only. Desktop
 * only, like the panel.
 */
export function MyViewsHeaderButton() {
  const open = useMyViewsPanelOpen();
  const desktop = useMediaQuery("(min-width: 1024px)");
  if (!desktop) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          onClick={() => setMyViewsPanelOpen(!open)}
          aria-label="My views"
          aria-pressed={open}
          className={cn(
            "flex h-9 w-9 items-center justify-center rounded-md transition-colors",
            open
              ? "bg-primary-dim text-primary"
              : "text-muted-foreground hover:bg-row-hover hover:text-foreground",
          )}
        >
          <Bookmark size={17} strokeWidth={1.75} />
        </button>
      </TooltipTrigger>
      <TooltipContent side="bottom">My views</TooltipContent>
    </Tooltip>
  );
}
